/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Contact_PositionInputs */

const en_clients_field_contact_position = /** @type {(inputs: Clients_Field_Contact_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position`)
};

const pt_br2_clients_field_contact_position = /** @type {(inputs: Clients_Field_Contact_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargo`)
};

/**
* | output |
* | --- |
* | "Position" |
*
* @param {Clients_Field_Contact_PositionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_contact_position = /** @type {((inputs?: Clients_Field_Contact_PositionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Contact_PositionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_contact_position(inputs)
	return pt_br2_clients_field_contact_position(inputs)
});